import { useStore } from 'vuex';

/**
 * Composable para gestionar las llamadas API de datos de ubicación.
 * Responsabilidad única: estados, ciudades y datos geográficos de masters.
 */
export function useLocationAPI() {
  const store = useStore();

  /**
   * Obtiene la lista de estados de Venezuela.
   * @returns {Promise<Array>} Lista de estados
   */
  const getStates = async () => {
    const params = {
      url: 'master/state/all',
      params: {
        active: 1,
        id_country: 239,
        order_key: 'name',
        order_value: 'asc',
      },
    };
    try {
      const response = await store.dispatch('getData', params);
      if (response?.code === 200) {
        return response.data;
      }
      return [];
    } catch (error) {
      console.error('Error fetching states:', error);
      return [];
    }
  };

  /**
   * Obtiene ciudades de un estado específico.
   * @param {string|number} stateId
   * @returns {Promise<Array>} Lista de ciudades
   */
  const getCitiesByState = async (stateId) => {
    const params = {
      url: 'master/city/all',
      params: {
        active: 1,
        id_state: stateId,
        order_key: 'name',
        order_value: 'asc',
      },
    };
    try {
      const response = await store.dispatch('getData', params);
      if (response?.code === 200) {
        return response.data;
      }
      return [];
    } catch (error) {
      console.error('Error fetching cities:', error);
      return [];
    }
  };

  return {
    getStates,
    getCitiesByState,
  };
}
